import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  GetMarathonAdminByIdParams,
  GetMarathonAdminByIdResponse,
  GetMarathonUserRegisteredParams,
  GetMarathonUserRegisteredResponse,
  GetMarathonWithDistancesParams,
  GetMarathonWithDistancesResponse,
  GetMarathonsParams,
  GetMarathonsResponse,
  GetMarathonsDistancesPriceParams,
  GetMarathonsDistancesPriceResponse,
  GetMarathonsByIdParams,
  GetMarathonsByIdResponse,
  GetMarathonsAsAdminParams,
  GetMarathonsAsAdminResponse,
  GetMarathonsDistancesParams,
  GetMarathonsDistancesResponse,
  GetMarathonsActiveParams,
  GetMarathonsActiveResponse,
  GetMyMarathonsWithUnfinishedRegistrationParams,
  GetMyMarathonsWithUnfinishedRegistrationResponse,
  GetMarathonsHasUserInsuranceParams,
  GetMarathonsHasUserInsuranceResponse,
  DeleteMarathonsParams,
  DeleteMarathonsResponse,
  DeleteMarathonsNonActivatedPromocodesParams,
  PutMarathonsStatusBody,
  PutMarathonsStatusResponse,
  GetMarathonsLookupParams,
  GetMarathonsLookupResponse,
  GetMarathonParticipantImagesRes,
  GetMarathonParticipantImagesParams,
  GetMyMarathonParticipantImagesParams,
  GetMyMarathonParticipantImagesRes,
} from "./types";
import { List } from "../../slice/types";

export const MarathonsAPI = {
  getMarathonWithDistances: async ({
    marathonId,
  }: GetMarathonWithDistancesParams): Promise<GetMarathonWithDistancesResponse> => {
    const response = await axiosApi.get<GetMarathonWithDistancesResponse>(
      `/marathons/${marathonId}/withDistances`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonAdminById: async ({
    marathonId,
  }: GetMarathonAdminByIdParams): Promise<GetMarathonAdminByIdResponse> => {
    const response = await axiosApi.get<GetMarathonAdminByIdResponse>(
      `/marathons/admin/${marathonId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonUserRegistered: async (
    marathonId: number,
    params: GetMarathonUserRegisteredParams
  ): Promise<GetMarathonUserRegisteredResponse> => {
    const response = await axiosApi.get<GetMarathonUserRegisteredResponse>(
      `/marathons/${marathonId}/userRegistered`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathons: async (
    params: GetMarathonsParams
  ): Promise<GetMarathonsResponse> => {
    const response = await axiosApi.get<GetMarathonsResponse>(`/marathons`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  },
  getMarathonsDistancesPrice: async ({
    marathonId,
    distanceId,
    ...params
  }: GetMarathonsDistancesPriceParams): Promise<GetMarathonsDistancesPriceResponse> => {
    const response = await axiosApi.get<GetMarathonsDistancesPriceResponse>(
      `/marathons/${marathonId}/distances/${distanceId}/price`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonsById: async ({
    marathonId,
    ...params
  }: GetMarathonsByIdParams): Promise<GetMarathonsByIdResponse> => {
    const response = await axiosApi.get<GetMarathonsByIdResponse>(
      `/marathons/${marathonId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonsAsAdmin: async ({
    marathonId,
    ...params
  }: GetMarathonsAsAdminParams): Promise<GetMarathonsAsAdminResponse> => {
    const response = await axiosApi.get<GetMarathonsAsAdminResponse>(
      `/marathons/${marathonId}/asAdmin`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonsDistances: async ({
    marathonId,
    ...params
  }: GetMarathonsDistancesParams): Promise<GetMarathonsDistancesResponse> => {
    const response = await axiosApi.get<GetMarathonsDistancesResponse>(
      `/marathons/${marathonId}/distances`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonsActive: async (
    params: GetMarathonsActiveParams
  ): Promise<GetMarathonsActiveResponse> => {
    const response = await axiosApi.get<GetMarathonsActiveResponse>(
      "/marathons/active",
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMyMarathonsWithUnfinishedRegistration: async (
    params: GetMyMarathonsWithUnfinishedRegistrationParams
  ): Promise<GetMyMarathonsWithUnfinishedRegistrationResponse> => {
    const response =
      await axiosApi.get<GetMyMarathonsWithUnfinishedRegistrationResponse>(
        "/marathons/GetMyMarathonsWithUnfinishedRegistration",
        {
          params,
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  getMarathonsHasUserInsurance: async (
    params: GetMarathonsHasUserInsuranceParams
  ): Promise<GetMarathonsHasUserInsuranceResponse> => {
    const response = await axiosApi.get<GetMarathonsHasUserInsuranceResponse>(
      `/marathons/hasUserInsurance`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteMarathons: async ({
    marathonId,
  }: DeleteMarathonsParams): Promise<DeleteMarathonsResponse> => {
    const response = await axiosApi.delete<DeleteMarathonsResponse>(
      `/marathons/${marathonId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteMarathonsNonActivatedPromocodes: async ({
    marathonId,
  }: DeleteMarathonsNonActivatedPromocodesParams): Promise<void> => {
    await axiosApi.delete<void>(
      `/marathons/${marathonId}/non-activated-promocodes`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
  },
  putMarathonsStatus: async (
    body: PutMarathonsStatusBody
  ): Promise<PutMarathonsStatusResponse> => {
    const response = await axiosApi.put<PutMarathonsStatusResponse>(
      `/marathons/status`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMarathonsLookup: async (
    params: GetMarathonsLookupParams
  ): Promise<List<GetMarathonsLookupResponse>> => {
    const response = await axiosApi.get<List<GetMarathonsLookupResponse>>(`/marathons/lookup`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  },
  getMarathonParticipantImages: async (
    { marathonId,
      ...params }: GetMarathonParticipantImagesParams
  ): Promise<List<GetMarathonParticipantImagesRes>> => {
    const response = await axiosApi.get<List<GetMarathonParticipantImagesRes>>(`/marathons/${marathonId}/participantImages`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  },
  getMyMarathonParticipantImages: async (
    { marathonId,
      ...params }: GetMyMarathonParticipantImagesParams
  ): Promise<List<GetMyMarathonParticipantImagesRes>> => {
    const response = await axiosApi.get<List<GetMyMarathonParticipantImagesRes>>(`/marathons/${marathonId}/participantImages/me`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  },
};
